import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobal from '../../../global';
import { CookieService } from 'ngx-cookie-service';

@Injectable( {
    providedIn: 'root'
} )
export class UserProfileService {

    constructor( private http: HttpClient, private cookieService: CookieService ) {
    }

    getuserInfo( UserId ) {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json',
            [ myGlobal.TOKEN ]: this.cookieService.get( 'Token' ),
            [ myGlobal.PROVIDER ]: this.cookieService.get( 'Provider' )
        } );
        const options = {headers: headers};

        return this.http.get( myGlobal.USER_MANAGEMENT + '/' + 'users/' + UserId, options );
    }

    postChangePassword( passwordChange ) {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json'
        } );
        const options = {headers: headers};

        return this.http.post( myGlobal.AUTHENTICATION + '/' + 'change_password', passwordChange, options );

    }

    /* https://dev-api.homesmartify.co/user/v1/users/0498ef29-c99f-43cc-9f39-5a856ddf10f4 */

    postUpdateUser( user ) {

        const userId = {
            'userId': this.cookieService.get( 'userId' ) || 'na',
        };

        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json',
            [ myGlobal.TOKEN ]: this.cookieService.get( 'Token' ),
            [ myGlobal.PROVIDER ]: this.cookieService.get( 'Provider' )
        } );
        const options = {headers: headers};

        return this.http.put( myGlobal.USER_MANAGEMENT + '/' + 'users' + '/' + userId.userId, user, options );

    }

}
